// import HslToHex from "./HslToHex";

const GenerateColors = (count) => {
    const colors = [];
    const hueStep = 360 / count;
    let hue = 0;

    for (let i = 0; i < count; i++) {
        let s = 0;
        let l = 0;

        // Light red shades (pink)
        if ((hue >= 345 && hue <= 360) || (hue >= 0 && hue <= 15)) {
            s = 30 + Math.random() * 20; // low saturation
            l = 75 + Math.random() * 15; // high lightness
        } else if (hue >= 75 && hue <= 165) {
            // Light green shades (mint/lime)
            s = 30 + Math.random() * 15;
            l = 75 + Math.random() * 10;
        } else {
            // Other colors (vivid)
            s = 80;
            l = 55;
        }
        colors.push([hue, s, l]);
        hue = (hue + hueStep) % 360;
    }

    return colors;
};

export default GenerateColors;
